import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 11l-3 3l-3 -3","key":"svg-0"}],["path",{"d":"M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0 -18z","key":"svg-1"}]]

const IconCircleChevronDown = createReactComponent('outline', 'circle-chevron-down', 'CircleChevronDown', __iconNode);

export default IconCircleChevronDown;